module.exports = __webpack_public_path__ + "static/media/icon_vandalismo.9f70685f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_vandalismo.svg
// module id = 527
// module chunks = 0